import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThumbUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#7F7F7F"
        d="M14 5.583c.3 0 .575.125.825.375s.375.525.375.825v.95c0 .09-.009.173-.025.25a.91.91 0 0 1-.075.217l-1.984 4.65c-.1.233-.286.417-.558.55-.272.133-.536.2-.792.2L4.4 13.583v-8l3.9-3.9c.21-.21.452-.347.725-.408a.999.999 0 0 1 .733.092c.217.122.356.32.417.591.06.273.058.57-.009.892L9.6 5.583zm-8.4.5v6.3H12l2-4.65v-.95H8.133L8.95 2.75zm-3.6 7.5c-.345 0-.63-.117-.859-.352a1.174 1.174 0 0 1-.341-.848v-5.6c0-.33.114-.612.341-.847.228-.235.514-.353.859-.353h2.4v1.2H2v5.6h2.4v1.2z"
      />
    </g>
  </svg>
);
export default SvgThumbUp;
